import { Injectable } from '@angular/core';
import { PtyLdService } from './pty-ld.service';
import { PtyDbService } from './pty-db.service';
import { Platform } from '@ionic/angular';
import { Events } from './events.service';
import {TranslationService} from "./translation.service";

@Injectable({
    providedIn: 'root'
})
export class PtyNotificationService {

    deviceInfo: any = null;
    isAndroid = true;
    id = 1;

    /* Vars for notifications */
    private stats: any = {
        notifications: { unread: 0, total: 0 },
        helped: 0,
        response_time: '0s',
        conversations: 0,
        messages: 0,
        most_active: [],
        top_ten: [],
        seekers_waiting: 0,
        loaded: false,
    };

    constructor(
        private ld: PtyLdService,
        private db: PtyDbService,
        public platform: Platform,
        private events: Events,
    ) {

    }

    setStats(stats: any) {
        this.stats = stats;
    }

    getStats() {
        return this.stats;
    }

    addToStat(statName: any, qty: any) {

        if (statName === 'notifications.unread') {
            this.stats.notifications.unread += qty;
        } else if (statName === 'notifications.total') {
            this.stats.notifications.total += qty;
        } else if (this.stats[statName] === null || typeof this.stats[statName] === 'undefined') {
            return;
        }
        if (statName === 'notifications') {
            this.stats[statName].unread += qty;
            this.stats[statName].total += qty;
        }
    }

    async initPushRegistration() {

    }

    showLocalNotification(notification: any, explanationPhrase: string = null, duration = 4000, buttonsOverride = []) {
        // Note: intentionally overriding duration to 4000 here for this specific use-case
        console.log("calling local notification", notification)
        this.events.publish('updateUnreadMessages', 'Update');
        this.events.publish('updateUnreadMessagesOnAPP',);
        this.events.publish('updateUnreadMessagesOnPool',);
        this.events.publish('MessageNotification', notification);

        this.ld.newMessageToast(this.parseNotification(notification, explanationPhrase), duration, buttonsOverride);
    }

    parseNotification(notification: any, explanationPhrase: string = null) {
        if (!explanationPhrase) {
            explanationPhrase = 'New Message Received';
        }

        if (typeof notification === 'object'
            && typeof notification.extra_data === 'object'
            && typeof notification.extra_data.msg_text === 'string'
        ) {
            notification = notification.extra_data.msg_text;
        }

        return `${explanationPhrase} \n ${notification}`;
    }

}
